import Vue from "vue";

const formatNotificationText = (text = "") => {
  if (text.length >= 200) {
    return `${text.substring(0, 199)}...`;
  }
  return text;
};

export const useNotification = {
  data() {
    return {
      notificationGroup: "main",
    };
  },
  methods: {
    showWarningNotification(text, duration = 3000) {
      Vue.notify({
        group: this.notificationGroup,
        type: "warn",
        title: "Внимание!",
        text: formatNotificationText(text),
        duration,
      });
    },
    showSuccessNotification(text, duration = 1200) {
      Vue.notify({
        group: this.notificationGroup,
        type: "success",
        title: "Успех!",
        text: formatNotificationText(text),
        duration,
      });
    },
    showStandardNotification(text, duration = 3000) {
      Vue.notify({
        group: this.notificationGroup,
        title: "Примечание",
        text: formatNotificationText(text),
        duration,
      });
    },
    showErrorNotification(text, duration = 3000) {
      Vue.notify({
        group: this.notificationGroup,
        type: "error",
        title: "Ошибка!",
        text: formatNotificationText(text),
        duration,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useNotification.js